import Dexie, { type Table } from 'dexie';
import type AuthUser from '~/types/authUser';

export type SyncQueuePayload =
  | { data: { id: string; status: 'execution'; execution: { startDate: string } } }
  | {
      data: {
        id: string;
        isCompleted: boolean;
        actionDate: string | null;
        completionDate: string;
        supplierId: string | null;
        collaboratorIds: string[];
        estimatedCost: number | null;
        realCost?: number;
        observation: string;
        attachments: Array<{ category?: string; url: string }>;
        ratingSupplier: number | null;
        completedBy: string;
        stockItems: Array<{ stockItemId: string; quantity: number; price: number }>;
        sourceWarehouseId?: string | undefined;
      };
    }
  | { user: AuthUser }
  | { data: Record<string, unknown> };

export interface SyncQueue {
  id: string;
  type:
    | 'execute'
    | 'complete'
    | 'update_profile'
    | 'create_equipment'
    | 'update_equipment'
    | 'delete_equipment'
    | 'create_local'
    | 'update_local'
    | 'delete_local';
  maintenanceId?: string;
  entityId?: string;
  payload: SyncQueuePayload;
  status: 'pending' | 'syncing' | 'synced' | 'error';
  retries: number;
  error?: string;
  createdAt: number;
  updatedAt: number;
}

export interface OfflineAttachment {
  id: string;
  maintenanceId: string;
  file: Blob;
  originalName: string;
  mimeType: string;
  size: number;
  category?: string;
  uploaded: boolean;
  uploadedUrl?: string;
  createdAt: number;
  updatedAt: number;
}

class EdificaDatabase extends Dexie {
  syncQueue!: Table<SyncQueue>;
  offlineAttachments!: Table<OfflineAttachment>;

  constructor() {
    super('edifica-db');

    this.version(2).stores({
      syncQueue: 'id, type, status, createdAt, updatedAt',
      offlineAttachments: 'id, maintenanceId, uploaded, createdAt, updatedAt'
    });
  }
}

export const db = new EdificaDatabase();
